if (!customElements.get('anchor-nav')) {
  customElements.define(
    'anchor-nav',
    class AnchorNav extends HTMLElement {
      constructor() {
        super();
        this.links = Array.prototype.slice.call(this.querySelectorAll('.anchor-nav__link'));
        this.targets = this.links
          .map((link) => document.getElementById(link.dataset.targetId))
          .filter(Boolean);

        this.links.forEach((link) => link.addEventListener('click', this.onClick.bind(this)));

        if ('IntersectionObserver' in window && this.targets.length) {
          this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
            rootMargin: `-${this.getStickyOffset() + 10}px 0px -70% 0px`,
            threshold: 0,
          });
          this.targets.forEach((target) => this.observer.observe(target));
        }
      }

      getStickyOffset() {
        const header = document.querySelector('sticky-header, .shopify-section-header');
        const wrapper = this.closest('.anchor-nav-wrapper');
        let offset = 0;
        if (header && getComputedStyle(header).position === 'sticky') {
          offset += header.offsetHeight;
        }
        if (wrapper && wrapper.classList.contains('anchor-nav-wrapper--sticky')) {
          offset += wrapper.offsetHeight;
        }
        return offset;
      }

      onClick(event) {
        const link = event.currentTarget;
        const target = document.getElementById(link.dataset.targetId);
        if (!target) return;

        event.preventDefault();

        const offset = this.getStickyOffset() + 20;
        const targetTop = target.getBoundingClientRect().top + window.scrollY - offset;
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        window.scrollTo({
          top: targetTop,
          behavior: prefersReducedMotion ? 'auto' : 'smooth',
        });

        history.pushState(null, '', `#${link.dataset.targetId}`);
      }

      onIntersect(entries) {
        entries.forEach((entry) => {
          const link = this.links.find((l) => l.dataset.targetId === entry.target.id);
          if (!link) return;
          if (entry.isIntersecting) {
            this.links.forEach((l) => l.classList.remove('anchor-nav__link--active'));
            link.classList.add('anchor-nav__link--active');
          }
        });
      }
    }
  );
}
